import {enqueueSnackbar} from 'notistack';
import globalSettingsManagerUtil from './global-settings-manager-util';
import eventManagerUtil from './event-manager-util';
import isOrganicUtil from './is-organic-util';
import locales from '../locales/locales';
import config from '../constants/config';
const sendReqUtil=async(endpoint,body,uploadId)=>{
    if(!isOrganicUtil()){
        return {
            body:{},
            status:500,
        };
    }
    const xhr=new XMLHttpRequest();
    xhr.open(
        body?'POST':'GET',
        config.API_URL+endpoint,
        true,
    );
    if(body&&body.constructor.name==='Object'){
        xhr.setRequestHeader('Content-Type','application/json');
    }
    const token=globalSettingsManagerUtil.getGlobalSettings().token;
    if(token){
        xhr.setRequestHeader('Authorization',`Bearer ${token}`);
    }
    //xhr.withCredentials=true;
    xhr.upload.addEventListener('progress',(e)=>{
        if(uploadId&&e.lengthComputable){
            eventManagerUtil.emitAll(`upload-progress-${uploadId}`,e.loaded/e.total);
        }
    });
    let [resBody,status]=await new Promise((resolve,_)=>{
        xhr.addEventListener('load',()=>{
            resolve([xhr.responseText,xhr.status]);
        });
        const handleError=()=>{
            resolve(['',500]);
        };
        xhr.addEventListener('error',handleError);
        xhr.addEventListener('timeout',handleError);
        xhr.addEventListener('abort',handleError);
        xhr.send(body&&body.constructor.name==='Object'?JSON.stringify(body):body);
    });
    if(status>=500){
        enqueueSnackbar(locales.utilUnknownError[globalSettingsManagerUtil.getGlobalSettings().lang],{variant:'error'});
    }
    try{
        resBody=JSON.parse(resBody);
    }
    catch(err){}
    return {
        body:resBody,
        status:status,
    };
};
export default sendReqUtil;

